/* ----------------------------------------------------------------------------
	Contact form handler
	- Loads Botpoison for spam protection
	- Intercepts form submission to send via fetch (AJAX)
	- Shows success/error messages inline (no redirect to Formspark)
	- Gracefully degrades: if JS fails, form submits to Formspark normally
---------------------------------------------------------------------------- */
(() => {
	/* ------------------------------------------------------------------------
		Wait for DOM, then attach handler
	---------------------------------------------------------------------------- */
	function initForm() {
		const form = document.querySelector('.contact-form');
		if (!form) return;

		// Lazy-load Botpoison on first interaction (contact.js ships on every page now)
		const loadBotpoison = () => {
			if (document.querySelector('script[data-botpoison]')) return;
			const script = document.createElement('script');
			script.src = 'https://unpkg.com/@botpoison/browser';
			script.async = true;
			script.dataset.botpoison = '';
			document.head.appendChild(script);
		};
		form.addEventListener('focusin', loadBotpoison, { once: true });

		const submitBtn = document.getElementById('form-submit');
		const statusEl = document.getElementById('form-status');

		form.addEventListener('submit', async (e) => {
			e.preventDefault();
			loadBotpoison();

			// --- Clear previous status ---
			statusEl.className = 'form-status';
			statusEl.textContent = '';

			// --- Set loading state ---
			const originalText = submitBtn.textContent;
			submitBtn.textContent = 'Sending…';
			submitBtn.disabled = true;

			try {
				// --- Gather form data ---
				const formData = new FormData(form);

				// --- Botpoison token (if loaded) ---
				if (typeof window.Botpoison !== 'undefined') {
					const bp = new window.Botpoison();
					const token = await bp.generate();
					formData.append('_botpoison', token);
				}

				// --- Convert FormData to URL-encoded string ---
				// (avoids CORS preflight that application/json triggers)
				const params = new URLSearchParams();
				for (const [key, value] of formData.entries()) {
					params.append(key, value);
				}

				// --- Send to Formspark via fetch ---
				const response = await fetch(form.action, {
					method: 'POST',
					headers: {
						'Content-Type': 'application/x-www-form-urlencoded',
						Accept: 'application/json',
					},
					body: params.toString(),
				});

				if (response.ok) {
					// --- Success ---
					statusEl.className =
						'form-status form-status--visible form-status--success';
					statusEl.textContent =
						"Thank you! Your message has been sent. We'll get back to you soon.";
					form.reset();
				} else {
					// --- Server error ---
					statusEl.className =
						'form-status form-status--visible form-status--error';
					statusEl.textContent =
						'Something went wrong while sending your message. Please try again, or contact us by email or phone.';
				}
			} catch {
				// --- Network or other error ---
				statusEl.className =
					'form-status form-status--visible form-status--error';
				statusEl.textContent =
					'Unable to connect. Please check your internet connection and try again.';
			} finally {
				// --- Restore button ---
				submitBtn.textContent = originalText;
				submitBtn.disabled = false;
			}
		});
	}

	/* ------------------------------------------------------------------------
		Run after DOM is ready
	---------------------------------------------------------------------------- */
	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', initForm);
	} else {
		initForm();
	}
})();
